import React from 'react';
import PropTypes from 'prop-types';

import Link from '../../../../library/link/link';
import { AngleRightLightIcon } from '../../../../shared/icons/icons';

import './cms-shopping-guide.scss';

function CmsShoppingGuide(props) {
  const { sections } = props;
  const [leftPanel, rightPanel] = sections || [];

  return (
    <div styleName="container">
      {leftPanel && (
        <div styleName="panel">
          <img
            alt={leftPanel?.image?.altText}
            src={leftPanel?.image?.url}
            styleName="left-image"
          />
          <div styleName="left-content">
            <h3 styleName="heading">{leftPanel?.heading}</h3>
            <p styleName="info">{leftPanel?.info}</p>
            {leftPanel?.link && (
              <Link styleName="link" to={leftPanel.link.href}>
                {leftPanel.link.text}
                <AngleRightLightIcon styleName="icon" />
              </Link>
            )}
          </div>
        </div>
      )}

      {rightPanel && (
        <div styleName="panel">
          <img
            alt={rightPanel?.image?.altText}
            src={rightPanel?.image?.url}
            styleName="right-image"
          />
          <div styleName="right-content">
            <h3 styleName="heading">{rightPanel?.heading}</h3>
            <p styleName="info">{rightPanel?.info}</p>
            {rightPanel?.link && (
              <Link styleName="link" to={rightPanel.link.href}>
                {rightPanel.link.text}
                <AngleRightLightIcon styleName="icon" />
              </Link>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

CmsShoppingGuide.propTypes = {
  sections: PropTypes.array
};

export default CmsShoppingGuide;
